module.exports = __webpack_public_path__ + "img/icon-download-2--white.814b360c.svg";